<div class = "overlayForPopups">
    <div cdkDrag>
    <uitk-dialog uitkId="notesAction" [(showModal)]="dialog.show" [closeBtn]="true" (onModalHidden)="closeDialog()" >
    
      <uitk-dialog-header>
        <div cdkDragHandle>
          Notes
        </div>
      </uitk-dialog-header>
      <uitk-dialog-content>
        <div id="loadingSpinner" class="uitk-l-grid" [hidden]="modeService.mode !== Mode.OrderNotesWait">
          <uitk-loading-indicator uitkId="spinner" [visibleText]="'Processing...'" spinnerSize="large">
          </uitk-loading-indicator>
        </div>
    
        <div class="container-fluid" [hidden]="!isAddEditNote">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <label class="col-lg-4" uitkLabel>Created Date</label>
                <div class="col-lg-8">
                  <uitk-form-field>
                    <input uitkInput class="textbox" id="createdDate" type="text" disabled  [value]="selectedNote.createdDate | date: 'MM/dd/yyyy'"/>
                  </uitk-form-field>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <label class="col-lg-4" uitkLabel>User Name</label>
                <div class="col-lg-8">
                  <uitk-form-field>
                    <input uitkInput class="textbox" id="username" type="text" disabled [(ngModel)]="selectedNote.userName" />
                  </uitk-form-field>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row mt-3">
            <div class="col-lg-12">
              <div class="row">
                <label class="col-lg-2" uitkLabel>Notes</label>
                <div class="col-lg-10">
                  <uitk-form-field>
                    <textarea uitkTextarea id="notestext" [textLimit]="maxInvoiceNoteLength"
                    name="notesTextInput" [disabled]="!this.isAuthorized"
                    #notesTextInput="ngModel" [required]="true" [(ngModel)]="selectedNote.noteText" (input)="noteTextChange()"></textarea>
                    <uitk-form-field-error *ngIf="showNotesError">
                      Notes is required
                    </uitk-form-field-error>
                  </uitk-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-xs-12">
              <div class="actionButtons">
                <uitk-dialog-actions>
                  <button class="uitk-c-button uitk-c-button--default uitk-u-margin--xxs" [disabled]="selectedNote.noteText === ''" (click)="saveNote()">
                    Save
                  </button>
                  <button class="uitk-c-button uitk-c-button--ghost uitk-u-margin--xxs" (click)="cancelDialog()">
                    Cancel
                  </button>
                </uitk-dialog-actions>
              </div>
            </div>
          </div>
        </div>
    
        <div class="container-fluid mt-3" [hidden]="this.isAddEditNote">
          <div class="row mt-4" id="notesdiv"  *ngIf="this.currentNote">
            <div class="continer-fluid">
              <div class="row">
                <div class="col-md-3">
                  <b>{{ this.currentNote.createdDate | date: 'MM/dd/yyyy hh:mm:ss a' }}</b><br>
                  <span class="userName">{{ this.currentNote.userName }}</span>
                </div>
                <div class="col-md-9">
                  <div class="float-end">
                    <b>{{ 'Invoice Note' }}</b>
                    <span id="orderId" *ngIf="this.currentNote.orderId === orderService.orderDto.id">&nbsp;
                      {{ this.currentNote.orderId }}
                    </span>
                    <span id="orderId" *ngIf="this.currentNote.orderId !== orderService.orderDto.id">&nbsp;
                      <a href="#" target="_blank" [routerLink]="['/order', this.currentNote.orderId]">{{ this.currentNote.orderId }}</a>
                    </span>
                    <span  [hidden]="this.currentNote.orderId !== orderService.orderDto.id && (modeService.mode !== Mode.Edit) || !this.currentNote.isEditEnabled" class="uitk-icon uitk-icon-edit sm-icon " id="editIcon" *appShowResource="'OrderInquiryAdditionalActionsEditInvoiceNotes'">
                      <a class="link" (click)="onEdit(this.currentNote)">Edit</a>
                    </span><br>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="textdisable" id="notesText-{{this.currentNote.id}}">
                  <b>Note:</b> {{ this.currentNote.noteText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </uitk-dialog-content>
    </uitk-dialog>
    </div>
    </div>